export const DIVIDER_SPRING_PROPS = Object.freeze({
    from: {
        opacity: 0,
        translation: -25
    },
    to: {
        opacity: 1,
        translation: 0
    }
});
